export const setPageTitle = (title: string) => {
  document.title = `${title} | Code Coast Learn`;
};
